module.exports = __webpack_public_path__ + "search-by-algolia-light-background-8762ce8b.9769190d.svg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/logos/search-by-algolia-light-background-8762ce8b.svg
// module id = ./public/assets/images/logos/search-by-algolia-light-background-8762ce8b.svg
// module chunks = main